'use client';

import { ErrorFallback } from '@/globals/errorBoundary/ErrorBoundary';

export default ErrorFallback;
